import { Injectable } from '@angular/core';
import { DatasetService } from '../dataset/dataset.service';
import { HttpClient } from '@angular/common/http';
import { LtmsWorkflowDataSourceService } from '../data-source/ltms-workflow-data-source.service';
import * as _ from 'lodash';
@Injectable({
    providedIn: 'root'
})

export class LtmsDataSource{

    constructor(
        private _datasets:DatasetService,
        private _http:HttpClient,
        private LtmsWorkflowDataSource:LtmsWorkflowDataSourceService
    ){}
    getData(customParam, params) {
        return new Promise((resolve)=>{
            var prefillValue = null;
            // ************ issueId within params: Check for Issue Id for the existing value****************//
            if (params && params["issueDetail"] && params["issueDetail"]["tags"]) {
                var tags = params["issueDetail"]["tags"];
                var field_id = customParam["field_id_with_hyphen"] || customParam["field_id"];
                prefillValue = tags[field_id];
            }
    
            // Get data when datasource is available and (renderData is true or have the prefillValue). In case of prefillValue we need all options and set the specific value.
            if (customParam && customParam["datasource"] && (params["renderData"] || prefillValue)) {
                if (customParam["datasource"]["type"] == 1) {
                    // Fetch data through DATASET if type of datasource is 1.
    
                    var apiParam = {
                        // Commented by Hitesh due to brand_id is not required to get dataset value as we are passing the dataset_id.
                        // "brand_id": params["brandId"],
                        "dataset_id": customParam["datasource"]["options"]["dataset_id"]
                    }
                    this._datasets.getDatasetValues(apiParam, (response:any)=> {
                        if (response["code"] == 0) {
                            resolve({ "data": response["dataset_values"], "prefillValue": prefillValue, "error": null });
                        } else {
                            resolve({ "data": null, "error": response });
                        }
                    });
                } else if (customParam["datasource"]["type"] == 2) {
                    // Data needs to be fetched from API.
                    if (!_.isEmpty(customParam["datasource"]["options"])) {
                        if (customParam["datasource"]["options"]["isAjax"]) {
                            resolve({ "data": [], "error": null, "prefillValue": prefillValue });
                        } else {
                            this.getDataFromAPI(customParam["datasource"]["options"], function(error, response) {
                                if (error) {
                                    console.warn("Problem while fetching data for the custom parameter from the API.")
                                    resolve({ "data": null, "error": error });
                                } else {
                                    // console.log("+++++ type 2 data source data getDataFromAPI",response)
                                    resolve({ "data": response, "prefillValue": prefillValue, "error": null });
                                }
                            })
                        }
                    } else {
                        resolve({ "data": null, "error": "Datasource's options not available for " + customParam.name });
                    }
                } else if (customParam["datasource"]["type"] == 3 && _.get(customParam, "datasource.options.expression")) {
                    // Resolve an expression
                    this.LtmsWorkflowDataSource.getData({
                        "type": 3,
                        "expression": customParam.datasource.options.expression,
                        "rules": _.get(customParam, "datasource.rules")
                    }, function(error, response) {
                        if (!error) {
                            resolve({ "data": response.data || [], "prefillValue": prefillValue, "error": null });
                        } else {
                            // console.log("+++++ type 3 LtmsWorkflowDataSource getData",response)
                            resolve({ "data": null, "error": "Unable to resolve expression for " + customParam.name });
                        }
                    });
                } else if (customParam["datasource"]["type"] == 4 && _.get(customParam, "datasource.options.values")) {
                    // Get the mentioned in the value field.
                    // console.log("+++++ type 4 LtmsWorkflowDataSource getData",customParam,)
                    resolve({ "data": customParam.datasource.options.values || [], "prefillValue": prefillValue, "error": null });
                } else {
                    resolve({ "data": [], "error": null });
                    // Data needs to be fetched from other source
                }
            } else {
                resolve({ "data": [], "prefillValue": prefillValue, "error": null });
            }
        })
    }
    /**
         * getDataFromAPI: This method will fetch the data from the API.
         * @param  {object}   params : Parameters such as 
         *                                 > method(POST, PUT, DELETE, GET)
         *                                 > url: URL of the API
         *                                 > data: This will the parameters for the API.
         */
    getDataFromAPI(params, cb) {
        if (!_.isEmpty(params) && this.validateParams(params)) {

            var req:any = {
                "method": params["method"],
                "url": params["url"],
                "params": params["data"]
            }
            this._http.request(req).subscribe((response:any)=> {
                if ((_.get(response, "data.code") == 0)) {
                    cb(false, response.data.data);
                } else if (_.get(response, "status") == 200) {
                    cb(false, response.data);
                } else {
                    cb(false, []);
                }
            },(response)=> {
                cb(true, false);
            });
        } else {
            console.warn("Custom Parameter: Required Parameters not sent for getting data from API.")
        }
    }

    validateParams(params) {
        if (params["method"] && params["url"] && params["data"]) {
            return true;
        } else {
            return false;
        }
    }

}

